import uiStore from './ui';

export default { ui: uiStore };
